export const fieldPtIconMappings = {
    STRING: 'SolidTextSurround',
    NUM: 'SolidOneTwoThree',
    DATE: 'SolidCalendar7',
    OPTION: 'SolidCheckboxOnOutline',
    LAYER: 'SolidTreeHorizontal',
    URL: 'SolidUrl',
};
export var FieldTabType;
(function (FieldTabType) {
    FieldTabType["STANDARD"] = "STANDARD";
    FieldTabType["CUSTOM_FIELD"] = "CUSTOM_FIELD";
})(FieldTabType || (FieldTabType = {}));
export const fieldColorList = ['#f05c6c', '#9fbc34', '#85c9c1', '#f7d370', '#53c0fe', '#f9abbb', '#0d89d5', '#79aff3', '#9099cb', '#9cb3c3', '#ffa66a', '#00af86'];
